<template>
    <div class="login-container bj">
        <div class="login">
            <img style="position: absolute;top:0px;right: -1px;" src="../../img/ty2.png" />
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
                label-position="left">

                <div class="title-container">
                    <img src="../../assets/logo2.jpg" v-if="this.GLOBAL.agentinfo.qq=='2764296524'"
                    style="    border-radius: 16px;
                    width: 150px;
                    margin: 0 auto 20px;
                    height: 100px;
                    display: block;
                    margin-top: -30px;">
                    <h3 class="title">华思税收分类编码查询</h3>
                  

                </div>



                <div style="display: flex;justify-content: space-between;">
                    <div style="flex:1;margin-right:10px">
                        <el-form-item prop="username">
                            <span class="svg-container">
                                <svg-icon icon-class="user" />
                            </span>
                            <el-input ref="username" v-model="loginForm.username" placeholder="首次使用点击右边免费注册"
                                name="username" type="text" tabindex="1" auto-complete="on" />

                        </el-form-item>
                    </div>
                    <div :style="{'visibility': (this.GLOBAL.agentinfo.zhuce? '':'hidden')}">
                        <el-link type="primary" @click="dialogFormVisiblemx=true;changepass=false"
                            style="margin-top:16px;text-decoration: underline;">
                            免费注册
                        </el-link>
                    </div>
                </div>
                <div style="display: flex;justify-content: space-between;">
                    <div style="flex:1;margin-right:10px">
                        <el-form-item prop="password">
                            <span class="svg-container">
                                <svg-icon icon-class="password" />
                            </span>
                            <el-input :key="passwordType" ref="password" v-model="loginForm.password"
                                :type="passwordType" placeholder="输入密码" name="password" tabindex="2" auto-complete="on"
                                @keyup.enter.native="handleLogin" />
                            <span class="show-pwd" @click="showPwd">
                                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                            </span>

                        </el-form-item>
                    </div>
                    <div>
                        <el-link type="primary" @click="dialogFormVisiblemx=true;changepass=true"
                            style="margin-top:16px;text-decoration: underline;">
                            修改密码
                        </el-link>
                    </div>
                </div>
                <!-- <el-link type="primary" icon="el-icon-edit" @click="dialogFormVisiblemx=true;changepass=true">修改密码
                </el-link> -->
                <el-checkbox v-model="checked">保存账号密码</el-checkbox>
                <div style="margin-top:10px" v-if="!agent">
                    <el-switch v-model="value1" inactive-text="专票普票、电子发票" active-text="机动车发票"></el-switch>
                </div>
                <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:10px;margin-top: 10px;"
                    @click.native.prevent="handleLogin">登陆</el-button>
                <!-- <el-button style="width:100%;margin-bottom:30px;margin-left:0px" @click="dialogFormVisiblemx=true">注册</el-button> -->
                <div  style="width:100%;margin-bottom:30px;margin-left:0px;color:black;display:flex;font-size:15px;justify-content: space-between;
    cursor: pointer;margin-bottom: 20px;">





                  
                </div>

                </el-switch>
                <div>

                    <div>
                        <i class="el-icon-phone" >电话:13635715047</i><br><br>
                        <i class="el-icon-user-solid" >微信:455586546</i><br><br>
                        <i class="el-icon-s-custom" >QQ:455586546</i><br><br>
                    </div>
                    

                </div>
            </el-form>
        </div>
        <!-- <div class="info">
        <h2>用科技,让复杂的事情更简单</h2>
        <span>解决痛点:</span></br>
        <div style="    border-left: 2px solid white;
    margin-left: 20px;
    padding-left: 5px;
    margin-top: 5px;margin-bottom: 20px;color:#c4cdda;">
            <span>销售清单明细很多，手工输入开票明细清单非常浪费时间。</span></br>
            <span>手工开票需要输入商品编码，费时费力。</span></br>
            <span>发票明细太多超出发票限额后，人工分票拆分麻烦。</span></br>
            <span>学校,企业,物业需要针对不同用户开具相同金额内容发票的痛点。</span></br>
        </div>

        <span> 核心功能:</span></br>
        <div style="    border-left: 2px solid white;
    margin-left: 20px;
    padding-left: 5px;
    margin-top: 5px;margin-bottom: 20px;color:#c4cdda;">

            <span>支持多种开软件(航天信息，百旺，Ukey)。</span></br>
            <span>自动识别匹配税收分类编码。</span></br>
            <span>支持EXCEL和WPS,支持含税和不含税导入。</span></br>
            <span>支持批量针对多购方开具发票,自动拆分发票。</span></br>
        </div>
        <span> 产品优势:</span></br>
        <div style="    border-left: 2px solid white;
    margin-left: 20px;
    padding-left: 5px;
    margin-top: 5px;color:#c4cdda;">

            <span>支持网页版和客户端版操作。</span></br>
            <span>不绑定电脑，不绑定税控盘。</span></br>
            <span>软件一次购买，免费升级。</span></br>
            <span>支持定制，实现您的进一步需求。</span></br>
        </div>
    </div> -->
        <el-dialog :close-on-click-modal="false" :title="changepass==true?'修改密码':'注册账号'"
            :visible.sync="dialogFormVisiblemx" width="390px" v-if="dialogFormVisiblemx" @close="changepass=false">
            <reg :changepass="changepass" :f="pfrom" @submit="submit"></reg>
        </el-dialog>
        <div class="star comet"></div>
    </div>
</template>

<script>
    import https from "@/https.js";
    import reg from "./reg";
    import $ from "jquery";
    import {
        setToken
    } from "@/components/auth"; // get token from cookie
    var $parthis;
    var $_GET = (function () {
        var url = window.document.location.href.toString();
        var u = url.split("?");
        if (typeof (u[1]) == "string") {
            u = u[1].split("&");
            var get = {};
            for (var i in u) {
                var j = u[i].split("=");
                get[j[0]] = j[1];
            }
            return get;
        } else {
            return {};
        }
    })();
    export default {
        name: "Login",
        components: {
            reg
        },
        data() {
            const validateUsername = (rule, value, callback) => {
                if (!validUsername(value)) {
                    callback(new Error("输入账号"));
                } else {
                    callback();
                }
            };
            const validatePassword = (rule, value, callback) => {
                if (value.length < 1) {
                    callback(new Error("输入密码"));
                } else {
                    callback();
                }
            };
            return {
                dialogFormVisiblemx: false,
                changepass: false,
                loginForm: {
                    username: "",
                    password: "",
                    jqm:'',
                    certinfo:'',
                    ly:'bm',
                },

                value1: false,
                loginRules: {
                    username: [{
                        required: true,
                        trigger: "blur",
                        message: "账号不能为空,点击右边免费注册就能试用。"
                    }],
                    password: [{
                        required: true,
                        trigger: "blur",
                        validator: validatePassword
                    }]
                },
                loading: false,
                passwordType: "password",
                redirect: undefined,
                checked: false,
                infotxt: '',
                pfrom: '',
                agent: this.GLOBAL.agent,
            };
        },
        mounted() {
            $parthis = this;
           
            console.log(this.GLOBAL.agentinfo)
            this.pfrom = $_GET['f'] || "";

            this.changepass = false;
            this.dialogFormVisiblemx = ($_GET['f']) ? true : false;
            let a = this.getCookie();
            if (!a) {
                this.loginForm.username = "";
                this.loginForm.password = "";
            }

        },
        watch: {
            $route: {
                handler: function (route) {
                    this.redirect = route.query && route.query.redirect;
                },
                immediate: true
            }
        },
        created() {
          
        },
        methods: {
            getdlinfo()
            {
                let _this=this;
                let url= "https://zhushou.huasivip.com/admin/api/public/index/reg/getdlinfo";
                https
                            .fetchPost(url,'')
                            .then(data => {
                                if (data.data.code == 200) {
                              
                                  //_this.$set( _this.GLOBAL.agentinfo,'qq',data.data.msg.qq);
                                    _this.GLOBAL.agentinfo.qq=data.data.msg.qq
                                    _this.GLOBAL.agentinfo.wx=data.data.msg.wx
                                    _this.GLOBAL.agentinfo.phone=data.data.msg.phone
                                    _this.GLOBAL.agentinfo.com=data.data.msg.com
                                    _this.GLOBAL.agentinfo.isurl=data.data.msg.isurl
                                    _this.GLOBAL.agentinfo.nohelp=data.data.msg.nohelp
                                    _this.$forceUpdate()
                                } 
                            })
                            .catch(err => {
                               // this.$message.error('登录失败，请重新登录');
                             
                             
                                console.log(err);
                            });
                    
            
            },
            doc() {

                let url = 'https://zhushou.huasivip.com/doc';
                //得到接口返回来的url地址，将其赋值给window.location.href，完成下载
                if (window.my) {
                    my.openurl(url);
                } else {

                    window.open(url);
                }

            },
            web() {

                let url = 'http://www.fxrjz.com';
                //得到接口返回来的url地址，将其赋值给window.location.href，完成下载

                if (window.my) {
                    my.openurl(url);
                } else {
                    window.open(url);

                }

            },
            websystem() {

                let url = 'https://zhushou.huasivip.com';
                if (window.my) {
                    my.openurl(url);
                } else {
                    url = 'https://zhushou.huasivip.com/admin/华思开票清单导入助手.exe';
                    //  alert("免费版用户请直接在线注册体验，正式版用户向客服索取。")
                    this.$alert("为了节约您的时间，免费版用户请直接在线注册体验。<br><strong style='color:red;font-size:20px'>网页版在线操作不影响核心体验。</strong><br>正式版用户向客服索取安装包。", "提示", {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                        callback: action => {
                            this.dialogFormVisiblemx = true
                        }
                    });


                    //   window.open(url);//网页里提示下载客户端


                }

            },
            showPwd() {
                if (this.passwordType === "password") {
                    this.passwordType = "";
                } else {
                    this.passwordType = "password";
                }
                this.$nextTick(() => {
                    this.$refs.password.focus();
                });
            },
            onloging() {
                let that = this;
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let url = this.changepass ?
                            "https://zhushou.huasivip.com/admin/api/public/index/reg/changepass" :
                            "https://zhushou.huasivip.com/admin/api/public/index/reg/login";

                        https
                            .fetchPost(url, this.loginForm)
                            .then(data => {
                                if (data.data.code == 200) {
                                    if (this.checked == true) {
                                        //传入账号名，密码，和保存天数3个参数
                                        this.setCookie(this.loginForm.username, this.loginForm.password, 30);
                                    } else {
                                        console.log("清空Cookie");
                                        //清空Cookie
                                        this.clearCookie();
                                    }
                                    if (window.my) {
                                        if (my.saveusername) {
                                            my.saveusername(that.loginForm.username)
                                        } else {
                                            if (this.agent) {
                                                this.$alert('此版本太老已经禁用，请联系客服获取新版。', '提示', {
                                                    confirmButtonText: '确定',
                                                    callback: action => {

                                                    }
                                                });
                                                return;
                                            }
                                            that.loading = false;

                                            this.$alert('此版本太老已经禁用，请在官网使用最新版。客服电话微信:13635715047。点击确定后打开官网。', '提示', {
                                                confirmButtonText: '确定',
                                                callback: action => {
                                                    my.openurl("http://www.fxrjz.com");
                                                }
                                            });
                                            return;
                                        }
                                    }
                                    setToken(data.data.msg.token);

                                    this.GLOBAL.userinfo = data.data.msg;

                                    this.GLOBAL.token = data.data.msg.token;
                                    this.GLOBAL.spbm = data.data.msg.spbm;

                                    this.GLOBAL.xsfname = data.data.msg.xsfname;
                                    this.GLOBAL.xsfsbh = data.data.msg.xsfsbh;
                                    this.GLOBAL.xsfdz = data.data.msg.xsfdz;
                                    this.GLOBAL.xsfkh = data.data.msg.xsfkh;

                                    this.$router.push({
                                        path: "/"
                                    });
                                    this.loading = false;
                                } else {
                                    this.$message.error(data.data.msg);

                                    this.loading = false;
                                }
                            })
                            .catch(err => {
                                this.$message.error('登录失败，请重新登录');
                                // this.$message(err.response.statusText);
                                this.loading = false;
                                console.log(err);
                            });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            handleLogin() {
                let that = this;
                if (this.value1 == true) {
                    this.$confirm('您选择了开具机动车发票, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        this.onloging();
                    }).catch(() => {

                        return;
                    });
                }
                else {
                    this.onloging();
                }



            },
            submit(data) {
                this.dialogFormVisiblemx = false;
                this.changepass=false;
                this.loginForm.username = data.name;
                this.loginForm.password = data.pass;
                this.loginForm.phone = data.phone;
            },
            //设置cookie
            setCookie(c_name, c_pwd, exdays) {
                var exdate = new Date(); //获取时间
                exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
                //字符串拼接cookie
                window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
                window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
                window.document.cookie = "userChecked" + "=" + this.checked + ";path=/;expires=" + exdate.toGMTString();
            },
            //读取cookie
            getCookie: function () {
                let s = false;
                if (document.cookie.length > 0) {
                    var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
                    for (var i = 0; i < arr.length; i++) {
                        var arr2 = arr[i].split('='); //再次切割
                        //判断查找相对应的值
                        if (arr2[0] == 'userName') {
                            this.loginForm.username = arr2[1]; //保存到保存数据的地方
                        } else if (arr2[0] == 'userPwd') {
                            s = true;
                            this.loginForm.password = arr2[1];
                        }
                        else if (arr2[0] == 'userChecked') {

                            this.checked = Boolean(arr2[1]);
                        }
                    }
                }
                return s;
            },
            //清除cookie
            clearCookie: function () {
                this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
            }

            //   this.$refs.loginForm.validate(valid => {
            //     if (valid) {
            //       this.loading = true
            //       this.$store.dispatch('user/login', this.loginForm).then(() => {
            //         // this.$router.push({ path: this.redirect || '/' })
            //          this.$router.push({ path: this.redirect || '/'})
            //         this.loading = false
            //       }).catch(() => {
            //         this.loading = false
            //       })
            //     } else {
            //       console.log('error submit!!')
            //       return false
            //     }
            //   })
            // }
        }

    };
    window.jqm = function (message) {

        $parthis.loginForm.jqm = message;
    }
    window.certinfo = function (message) {

$parthis.loginForm.certinfo = message;
}
    window.setusername = function (message) {

        $parthis.loginForm.username = message;
    }
</script>

<style lang="scss">
    .el-form-item__content {
        /* height: 45px !important; */
    }

    .el-dialog {
        /* display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        
        transform: translate(-50%, -50%);
      
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px); */

    }

    .el-dialog .el-dialog__body {
        /* flex: 1;
        overflow: auto; */
    }

    .star {
        width: 3px;
        height: 3px;
        border-radius: 50%;
        position: absolute;
        background-color: rgba(237, 205, 163, 0.8);
        box-shadow: 0 0 40px 0 rgba(237, 205, 163, 0.8), 0 0 20px 0 #ffffff;
        animation: glow 5s infinite;
    }

    .star--medium {
        width: 6px;
        height: 6px;
    }

    .star--big {
        width: 9px;
        height: 9px;
        box-shadow: 0 0 40px 0 #edcda3, 0 0 20px 0 #ffffff, inset 0 0 4px #ffffff;
    }

    .comet {
        width: 6px;
        height: 6px;
        background-color: rgba(255, 255, 255, 0.6);
        box-shadow: 0 0 40px 0 #edcda3, 0 0 20px 0 #ffffff,
            inset 0 0 8px rgba(255, 255, 255, 0.6);
        top: 0;
        left: 80%;
        opacity: 0.3;
        transform: rotate(-45deg) translate(0, -50px);
        animation: comet 6s infinite;
    }

    .comet:after {
        content: "";
        width: 20vw;
        height: 6px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.1);
        box-shadow: 0 0 20px rgba(237, 205, 163, 0.4);
        position: absolute;
        top: 0;
        left: 0;
    }

    @keyframes glow {
        0% {
            opacity: 0.9;
        }

        50% {
            opacity: 0.2;
        }

        100% {
            opacity: 0.9;
        }
    }

    @keyframes comet {
        0% {
            transform: rotate(-45deg) translateX(0);
            opacity: 0.3;
        }

        10% {
            opacity: 1;
        }

        20% {
            transform: rotate(-45deg) translateX(-100vw);
            opacity: 0;
        }

        100% {
            transform: rotate(-45deg) translateX(-100vw);
            opacity: 0;
        }
    }

    html,
    body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        /* overflow: hidden; */
    }

    /* 修复input 背景不协调 和光标变色 */
    /* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */
    input:-webkit-autofill {

        transition: background-color 5000s ease-in-out 0s;
    }

    $bg: #283443;
    $light_gray: #000;
    $cursor: #000;

    @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
        .login-container .el-input input {
            color: $cursor;
        }
    }

    /* reset element-ui css */
    .login-container {
        .el-input {
            display: inline-block;
            height: 30px;
            width: 80%;

            input {
                background: transparent;
                border: 0px;
                -webkit-appearance: none;
                border-radius: 0px;
                padding: 12px 5px 12px 5px;
                color: $light_gray;
                height: 30px;
                caret-color: $cursor;

                &:-webkit-autofill {
                    // box-shadow: 0 0 0px 1000px $bg inset !important;
                    -webkit-text-fill-color: $cursor !important;
                }
            }
        }

        .el-form-item {
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            color: #454545;
            flex: 1;
        }
    }
</style>

<style lang="scss" scoped>
    $bg: rgb(151, 138, 138);
    $dark_gray: rgb(151, 138, 138);
    $light_gray: #eee;

    .login-container::after {
        content: "";

        opacity: 0.5;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        position: absolute;
        z-index: -1;
    }

    .bj {
        background: url("~@/assets/bj.jpg") center center no-repeat;
    }

    .login-container {
        display: block;
        position: relative;
        min-height: 100%;
        width: 100%;
        background-color: $bg;
        overflow: hidden;

        .login-form {
            position: relative;
            width: 400px;
            max-width: calc(95% - 70px);
            padding: 60px 35px 0;
            margin: 0 auto;
            overflow: hidden;
        }

        .tips {
            font-size: 14px;
            color: #fff;
            margin-bottom: 10px;

            span {
                &:first-of-type {
                    margin-right: 16px;
                }
            }
        }

        .login {
            position: absolute;
            right: 50%;
            top: 50%;
            margin-right: -200px;
            margin-top: -290px;
            width: 400px;
            // max-width: 95%;
            height: auto;

            background: rgba(255, 255, 255, 0.99);
            border-radius: 12px;
            border-radius: 12px;
            overflow: hidden;
        }

        .info {
            color: #FFF;

            HEIGHT: 100%;
            POSITION: fixed;
            top: 15%;
            left: 139px;

        }

        .svg-container {
            padding: 6px 5px 6px 15px;
            color: $dark_gray;
            vertical-align: middle;
            width: 20px;
            display: inline-block;
        }

        .title-container {
            position: relative;

            .title {
                font-size: 26px;
                color: #000;
                margin: 0px auto 20px auto;
                text-align: center;
                font-weight: bold;
            }
        }

        .show-pwd {
            position: absolute;
            right: 10px;
            top: 7px;
            font-size: 16px;
            color: $dark_gray;
            cursor: pointer;
            user-select: none;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/login/index.vue


// WEBPACK FOOTER //
// src/components/login/index.vue